import type * as GraphQLTypes from '../../../graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpsertPackageCustomerPaymentMutationVariables = GraphQLTypes.Exact<{
  packageId: GraphQLTypes.Scalars['String'];
  input: GraphQLTypes.UpsertCustomerPaymentInput;
}>;


export type UpsertPackageCustomerPaymentMutationResult = (
  { __typename?: 'Mutation' }
  & Pick<GraphQLTypes.Mutation, 'upsertPackageCustomerPayment'>
);


export const UpsertPackageCustomerPaymentDocument = /*#__PURE__*/ gql`
    mutation upsertPackageCustomerPayment($packageId: String!, $input: UpsertCustomerPaymentInput!) {
  upsertPackageCustomerPayment(packageId: $packageId, input: $input)
}
    `;

/**
 * __useUpsertPackageCustomerPaymentMutation__
 *
 * To run a mutation, you first call `useUpsertPackageCustomerPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPackageCustomerPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPackageCustomerPaymentMutation, { data, loading, error }] = useUpsertPackageCustomerPaymentMutation({
 *   variables: {
 *      packageId: // value for 'packageId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertPackageCustomerPaymentMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPackageCustomerPaymentMutationResult, UpsertPackageCustomerPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPackageCustomerPaymentMutationResult, UpsertPackageCustomerPaymentMutationVariables>(UpsertPackageCustomerPaymentDocument, options);
      }
export type UpsertPackageCustomerPaymentMutationHookResult = ReturnType<typeof useUpsertPackageCustomerPaymentMutation>;